import { PERMISSION_CREATE_QUOTE, PERMISSION_EDIT_QUOTE } from '../permissions';

const SwivelChairGroupPermissions = {
  // Quotes
  [PERMISSION_CREATE_QUOTE]: true,
  [PERMISSION_EDIT_QUOTE]: true,
};

export default SwivelChairGroupPermissions;
